"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const adjustment_1 = require("services/adjustment");
const transhipment_types_1 = require("./transhipment.types");
const planning_types_1 = require("../planning.types");
const getDataGridTranshipment = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridTranshipment)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        if (response.data.length > 0) {
            payload.dataGrid = payload.dataGrid.concat(Object.assign(Object.assign({}, response.data[response.data.length - 1]), { type: 'Total', brand_name: '', jan: response.data.reduce(function (a, b) { return a + b.jan; }, 0), feb: response.data.reduce(function (a, b) { return a + b.feb; }, 0), mar: response.data.reduce(function (a, b) { return a + b.mar; }, 0), apr: response.data.reduce(function (a, b) { return a + b.apr; }, 0), may: response.data.reduce(function (a, b) { return a + b.may; }, 0), jun: response.data.reduce(function (a, b) { return a + b.jun; }, 0), jul: response.data.reduce(function (a, b) { return a + b.jul; }, 0), aug: response.data.reduce(function (a, b) { return a + b.aug; }, 0), sep: response.data.reduce(function (a, b) { return a + b.sep; }, 0), oct: response.data.reduce(function (a, b) { return a + b.oct; }, 0), nov: response.data.reduce(function (a, b) { return a + b.nov; }, 0), dec: response.data.reduce(function (a, b) { return a + b.dec; }, 0) }));
        }
        dispatch({ type: transhipment_types_1.planningTranshipmentTypes.SET_DATA_GRID_TRANSHIPMENT, payload });
        dispatch({
            type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isLoading: false }
        });
    }
});
const getDataGridHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridHistoryTranshipment)(dataStatesHistory);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: transhipment_types_1.planningTranshipmentTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGridHistory: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { uploaded_at: new Date(item.uploaded_at) });
            })
        };
        dispatch({ type: transhipment_types_1.planningTranshipmentTypes.SET_DATA_GRID_HISTORY, payload });
    }
});
const getLastSucceedUpload = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridHistoryTranshipment)(dataStatesHistory);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: transhipment_types_1.planningTranshipmentTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            lastUpdated: response.data.length > 0 ? response.data[0].uploaded_at : null,
        };
        dispatch({ type: transhipment_types_1.planningTranshipmentTypes.SET_LAST_SUCCEED_UPLOAD, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: transhipment_types_1.planningTranshipmentTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: transhipment_types_1.planningTranshipmentTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: transhipment_types_1.planningTranshipmentTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: transhipment_types_1.planningTranshipmentTypes.ON_SORT_CHANGE, payload });
};
const onSortChangeHistory = payload => dispatch => {
    dispatch({ type: transhipment_types_1.planningTranshipmentTypes.ON_SORT_CHANGE_HISTORY, payload });
};
const onFilterChangeHistory = payload => dispatch => {
    dispatch({ type: transhipment_types_1.planningTranshipmentTypes.ON_FILTER_CHANGE_HISTORY, payload });
};
const onDataStateChangeHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: transhipment_types_1.planningTranshipmentTypes.ON_PAGE_CHANGE_HISTORY, payload: { dataStatesHistory } });
});
const onCloseError = () => dispatch => {
    dispatch({
        type: transhipment_types_1.planningTranshipmentTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onUploadDocumentTranshipment = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { formdata, filename, year } = payload;
    const responseUpload = yield (0, adjustment_1._uploadDocumentTranshipment)(formdata);
    const responseProcess = yield (0, adjustment_1._uploadProcessTranshipment)({ filename, year });
    if (responseUpload.isError || responseProcess.isError) {
        const payload = {
            isError: responseUpload.isError || responseProcess.isError,
            errorCode: responseUpload.errorCode || responseProcess.errorCode,
            errorMessage: responseUpload.errorMessage || responseProcess.errorMessage,
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
        dispatch({ type: transhipment_types_1.planningTranshipmentTypes.SET_ERROR, payload });
    }
    else {
        dispatch({
            type: transhipment_types_1.planningTranshipmentTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, selectedYear: year, isLoadingUpload: false }
        });
        dispatch({
            type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isSuccess: true, isLoading: true }
        });
    }
});
const onDownloadTemplateDocument = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._downloadTemplateTranshipment)(payload);
    if (response.isError) {
        const payload = {
            isError: true,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
        dispatch({ type: transhipment_types_1.planningTranshipmentTypes.SET_ERROR, payload });
    }
    else {
        window.location.href = response.url;
        dispatch({
            type: transhipment_types_1.planningTranshipmentTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: payload.mutationMode, isLoadingDownload: false }
        });
    }
});
exports.default = {
    onSortChange,
    onCloseError,
    onFilterChange,
    onClickMutation,
    onDataStateChange,
    getDataGridHistory,
    onSortChangeHistory,
    getLastSucceedUpload,
    onFilterChangeHistory,
    getDataGridTranshipment,
    onDataStateChangeHistory,
    onDownloadTemplateDocument,
    onUploadDocumentTranshipment,
};
